import React, { useMemo } from "react";
import { Row, Col } from "antd";
import { connect } from "dva";
import TripCard from "./TripCard";
import styles from "./TripDetails.styles.less";

const TripDetails = ({
  adminShipmentView,
  vehicleAndLoadData,
  handleClickHardRoutePickup,
  handleClickHardRouteDropoff,
}) => {
  const adminShipmentData = useMemo(() => adminShipmentView?.data, [adminShipmentView]);

  const pickupNotesCount = useMemo(() => {
    let count = 0;

    if (adminShipmentData?.pickup?.instructions) count += 1;
    if (adminShipmentData?.load?.notesAtPickup) count += 1;

    return count;
  }, [adminShipmentData]);

  const dropoffNotesCount = useMemo(() => {
    let count = 0;

    if (adminShipmentData?.dropoff?.instructions) count += 1;
    if (adminShipmentData?.load?.notesAtDropoff) count += 1;

    return count;
  }, [adminShipmentData]);

  const originData = {
    ...adminShipmentData.pickupAddress,
    specialConditions: {
      requiresTWIC: adminShipmentData.requiresTWIC,
      requiresEModal: adminShipmentData.requiresEModal,
      requiresLotExit: adminShipmentData.requiresLotExit,
    },
    eta: adminShipmentData.pickupETA,
    actual: vehicleAndLoadData?.load?.pickedUpAt,
    daysOfWeekUnavailable: adminShipmentData?.pickup?.dayOfWeekRestricted || null,
    notesCount: pickupNotesCount,
  };

  const destinationData = {
    ...adminShipmentData.dropOffAddress,
    actual: vehicleAndLoadData?.load?.droppedOffAt,
    eta: adminShipmentData.dropOffETA,
    daysOfWeekUnavailable: adminShipmentData?.dropoff?.dayOfWeekRestricted || null,
    notesCount: dropoffNotesCount,
  };

  return (
    <Row style={{ maxWidth: "100%" }}>
      <Col lg={24} xl={12} className={styles.pickupCardWrapper}>
        <TripCard
          tripTime="Pickup"
          data={originData}
          hardRouteReason={originData.hardRouteReason}
          handleClickHardRoute={handleClickHardRoutePickup}
        />
      </Col>

      <Col lg={24} xl={12}>
        <TripCard
          tripTime="Dropoff"
          data={destinationData}
          hardRouteReason={destinationData.hardRouteReason}
          handleClickHardRoute={handleClickHardRouteDropoff}
        />
      </Col>
    </Row>
  );
};

export default connect(({ adminShipmentView }) => ({
  adminShipmentView,
  vehicleAndLoadData: adminShipmentView.vehicleAndLoadData,
}))(TripDetails);
